import React from "react";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import AgGridListViewProvider, { AgGridListViewProviderProps } from "./AgGridListViewProvider";
import AgGridListViewSection from "./AgGridListViewSection";

interface AgGridListViewProps<T extends AnyEntity> extends AgGridListViewProviderProps<T> {
  className?: string;
}

const AgGridListView = <T extends AnyEntity>({
  children,
  className,
  ...props
}: AgGridListViewProps<T>) => {
  return (
    <AgGridListViewProvider {...props}>
      <AgGridListViewSection className={className}>{children}</AgGridListViewSection>
    </AgGridListViewProvider>
  );
};

export default AgGridListView;
